import type { PlcManufacturerCodeLibrary } from "./types";

export const phoenix_contactCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "phoenix-contact",
  manufacturer_name: "Phoenix Contact",
  codes: [
    {
      id: "phoenix-axio0007",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: null,
      code: "AXIO0007",
      code_type: "PLCnext Engineer Error",
      title_ar: "Axioline PROFIsafe device يحتاج Safety PLC",
      description_ar: "AXIO0007 يظهر إذا أضفت جهاز safety-related إلى مشروع ما بيه Safety PLC مناسب.",
      symptoms: ["PLCnext Engineer يعرض AXIO0007", "ما تگدر تكمل تكوين جهاز PROFIsafe"],
      causes: ["الكنترولر القياسي ما يحتوي Safety PLC بالمشروع"],
      checks: [
        {
          step: 1,
          action: "راجع PLANT وتأكد من وجود Safety PLC مناسب.",
          expected: "Safety PLC موجود كجزء منفصل بالمشروع.",
          faulty: "المشروع بيه Controller عادي فقط.",
        }
      ],
      solutions: ["استخدم/أضف Controller type يتضمن Safety PLC مناسب حسب تصميمك."],
      severity: "عالية",
      source_title: "Phoenix Contact PLCnext Engineer Error Catalog",
      source_section: "AXIO0007 Axioline Error",
      keywords: ["Phoenix Contact", "PLCnext", "AXIO0007", "PROFIsafe"],
    },
    {
      id: "phoenix-axl-undervoltage",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: null,
      code: "0x0002",
      code_type: "Axioline Diagnostic",
      title_ar: "Undervoltage",
      description_ar: "Axioline diagnostic state 0x0002 يعني Undervoltage.",
      symptoms: ["I/O diagnostic fault", "0x0002"],
      causes: ["فولت التغذية أقل من المطلوب"],
      checks: [
        {
          step: 1,
          action: "قِس تغذية الـAxioline/field المناسبة بمعدة قياس مناسبة.",
          expected: "الفولت ضمن مواصفات الجهاز.",
          faulty: "الفولت واطي.",
        }
      ],
      solutions: ["صحح مصدر التغذية والربطات."],
      severity: "عالية",
      source_title: "Phoenix Contact Axioline diagnostic registers and error messages",
      source_section: "0x0002 Undervoltage",
      keywords: ["Phoenix Contact", "Axioline", "0x0002", "undervoltage"],
    },
    {
      id: "phoenix-axl-overvoltage",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: null,
      code: "0x0003",
      code_type: "Axioline Diagnostic",
      title_ar: "Overvoltage",
      description_ar: "Axioline diagnostic state 0x0003 يعني Overvoltage.",
      symptoms: ["I/O diagnostic fault", "0x0003"],
      causes: ["فولت التغذية أعلى من المطلوب"],
      checks: [
        {
          step: 1,
          action: "قِس التغذية.",
          expected: "ضمن المواصفة.",
          faulty: "أعلى من المجال المسموح.",
        }
      ],
      solutions: ["صحح مصدر التغذية قبل إعادة الخدمة."],
      severity: "حرجة",
      source_title: "Phoenix Contact Axioline diagnostic registers and error messages",
      source_section: "0x0003 Overvoltage",
      keywords: ["Phoenix Contact", "Axioline", "0x0003", "overvoltage"],
    },
    {
      id: "phoenix-axl-overtemp",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: null,
      code: "0x0005",
      code_type: "Axioline Diagnostic",
      title_ar: "Overtemperature",
      description_ar: "Axioline diagnostic state 0x0005 يعني Overtemperature؛ الوثيقة تعطي حد 95°C ضمن المثال.",
      symptoms: ["0x0005", "Module temperature fault"],
      causes: ["حرارة عالية", "تهوية أو حمل غير مناسب"],
      checks: [
        {
          step: 1,
          action: "افحص حرارة المحيط واللوحة والموديول.",
          expected: "الحرارة ضمن المواصفة.",
          faulty: "تشخيص overtemperature فعال.",
        }
      ],
      solutions: ["حسن التهوية وخفف سبب الحرارة.", "لا ترجع المعدة إذا الحرارة غير طبيعية."],
      severity: "حرجة",
      source_title: "Phoenix Contact Axioline diagnostic registers and error messages",
      source_section: "0x0005 Overtemperature",
      keywords: ["Phoenix Contact", "Axioline", "0x0005", "temperature"],
    },
    {
      id: "phoenix-axl-param-fault",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: null,
      code: "0x0100",
      code_type: "Axioline/PROFINET Diagnostic",
      title_ar: "PROFINET parameterization fault",
      description_ar: "الكود 0x0100 يدل على خطأ parameterization بـPROFINET.",
      symptoms: ["PROFINET device ما يدخل data exchange", "0x0100"],
      causes: ["Parameters مو مقبولة أو مو مطابقة للجهاز"],
      checks: [
        {
          step: 1,
          action: "قارن device parameters بملف الجهاز والتكوين.",
          expected: "Parameters مقبولة.",
          faulty: "يبقى parameterization fault.",
        }
      ],
      solutions: ["صحح إعدادات الجهاز وأعد تنزيل التكوين."],
      severity: "عالية",
      source_title: "Phoenix Contact Axioline diagnostic registers and error messages",
      source_section: "0x0100 PROFINET parameterization fault",
      keywords: ["Phoenix Contact", "PROFINET", "0x0100"],
    },
    {
      id: "phoenix-axl-backplane-power",
      manufacturer_id: "phoenix-contact",
      series_id: "plcnext-axc-f-2152",
      model: null,
      code: "0x0101",
      code_type: "Axioline Diagnostic",
      title_ar: "Backplane power fault",
      description_ar: "الكود 0x0101 يدل على Power supply fault بالـbackplane.",
      symptoms: ["Axioline station fault", "0x0101"],
      causes: ["Backplane power غير موجود أو مو طبيعي"],
      checks: [
        {
          step: 1,
          action: "افحص تغذية الـbackplane ووحدات power.",
          expected: "القدرة متوفرة ضمن المواصفة.",
          faulty: "backplane power fault يبقى فعال.",
        }
      ],
      solutions: ["صحح مصدر القدرة أو power module.", "افحص ترتيب الموديولات وحمل UBus."],
      severity: "حرجة",
      source_title: "Phoenix Contact Axioline diagnostic registers and error messages",
      source_section: "0x0101 Backplane power fault",
      keywords: ["Phoenix Contact", "Axioline", "0x0101", "backplane"],
    },
  ],
};
